import React from 'react';
import drupalSettings from 'drupalSettings';
import axios from "axios";
import PaginatedItems from "./tripResultsPaginated";
import { pdf as createPdf } from '@react-pdf/renderer';
import MyDocument from "./trip_pdf";
import {inArray} from "./utils/inArray";
import {mailtoBuilder} from "./utils/mailto";

const LANG = drupalSettings.path.currentLanguage;

class TripResults extends React.Component {
  constructor(props) {
    super(props);
    this.filterByTags = this.filterByTags.bind(this);
    this.generatePDF = this.generatePDF.bind(this);
    this.state = {
      loading: true,
      results: [],
      searchCategories: [],
      categories: [
        {

          slug: "food",
          api: "/trip/results?_format=json&food_types=",
          callAPI: "",
          icon: '/themes/custom/dsj/images/food-icon.svg',
          title: LANG === 'fr' ? 'Nourriture et boissons' : 'Food & Drink',
          subCategories: [],
          results: [],
          filteredResults: [],
          activeFilter: null,
          resultLine: LANG === 'fr' ? 'Vos choix en matière de nourriture et de boissons' : 'Your Food & Drink picks',

        },
        {
          slug: "history",
          api: "/trip/results?_format=json&subcategory_tags=",
          callAPI: "",
          icon: '/themes/custom/dsj/images/history-icon.svg',
          title: LANG === 'fr' ? 'Histoire' : 'History',
          subCategories: [],
          results: [],
          filteredResults: [],
          activeFilter: null,
          resultLine: LANG === 'fr' ? 'Vos choix en matière d\'histoire' : 'Your History picks',

        },
        {
          slug: "outdoor",
          api: "/trip/results?_format=json&subcategory_tags=",
          callAPI: "",
          icon: '/themes/custom/dsj/images/outdoor-icon.svg',
          title: LANG === 'fr' ? 'Aventure en plein air' : 'Outdoor Adventure',
          subCategories: [],
          results: [],
          filteredResults: [],
          activeFilter: null,
          resultLine: LANG === 'fr' ? 'Vos choix d\'aventures en plein air' : 'Your Outdoor Adventure picks',

        },
        {
          slug: "shopping",
          api: "/trip/results?_format=json&subcategory_tags=",
          callAPI: "",
          icon: '/themes/custom/dsj/images/shopping-icon.svg',
          title: LANG === 'fr' ? 'Magasinage' : 'Shopping',
          subCategories: [],
          results: [],
          filteredResults: [],
          activeFilter: null,
          resultLine: LANG === 'fr' ? 'Vos choix en matière de magasinage' : 'Your Shopping picks',

        },
        {
          slug: "art",
          api: "/trip/results?_format=json&urban_type=galleries",
          callAPI: "",
          icon: '/themes/custom/dsj/images/art-icon.svg',
          title: LANG === 'fr' ? 'Art et galeries' : 'Art and Galleries',
          subCategories: [],
          results: [],
          filteredResults: [],
          activeFilter: null,
          resultLine: LANG === 'fr' ? 'Vos choix en matière d\'art et de galeries' : 'Your Art and Galleries picks',

        },
        {
          slug: "recreation",
          api: "/trip/results?_format=json&subcategory_tags=",
          callAPI: "",
          icon: '/themes/custom/dsj/images/recreation.svg',
          title: LANG === 'fr' ? 'Loisirs' : 'Recreation',
          subCategories: [],
          results: [],
          filteredResults: [],
          activeFilter: null,
          resultLine: LANG === 'fr' ? 'Vos choix en matière de loisirs' : 'Your Recreation picks',

        },
        {
          slug: "tours",
          api: "/trip/results?_format=json&subcategory_tags=Guided and Self-Guided Tours",
          callAPI: "",
          icon: '/themes/custom/dsj/images/tours-icon.svg',
          title: LANG === 'fr' ? 'Visites guidées et autoguidées' : 'Guided and Self-Guided Tours',
          selectText: null,
          subCategories: [],
          results: [],
          filteredResults: [],
          activeFilter: null,
          resultLine: LANG === 'fr' ? 'Vos choix de visites guidées et autoguidées' : 'Your Guided and Self-Guided Tours picks',

        },
        {
          slug: "hotels",
          api: "/trip/results?_format=json&accomodation_types=",
          callAPI: "",
          icon: '/themes/custom/dsj/images/hotels-icon.svg',
          title: LANG === 'fr' ? 'Hébergement' :'Accommodations',
          subCategories: [],
          results: [],
          filteredResults: [],
          activeFilter: null,
          resultLine: LANG === 'fr' ? 'Vos choix en matière d\'hébergement' : 'Your Accommodations picks',

        }
      ],
      pdfUrl:null,
      mailtoLink: "",
    };

    this.pillarRef = null;
  }

  async componentDidMount() {
    let url = new URL(window.location.href);
    let urlParams = new URLSearchParams(url.search);
    let categories = urlParams.get('categories').split(',');
    let searchCategories = []
    let urlsArray = []
    let apiUrl = ""
    // match the selected categories with the categories in URLs
    categories.forEach((category, index) => {
      let cat = this.state.categories.find((cat) => cat.slug === category)
      if (cat) {
        cat.subCategories = urlParams.get(cat.slug + '-sub')
        if (cat.subCategories.length > 0) {
          apiUrl = LANG === 'fr' ? '/fr' + cat.api + cat.subCategories:cat.api + cat.subCategories
        }
        else {
          apiUrl = LANG === 'fr' ? '/fr' + cat.api:cat.api
        }
        apiUrl = apiUrl.replace(/\s+/g, '+')
        cat.callAPI = apiUrl;
        urlsArray.push(axios.get(apiUrl))
        searchCategories.push(cat)
      }
    })

    const results = await Promise.all(urlsArray);

    let membersIds = []

    results.forEach((result, index) => {
      // loop over the selected categories
      searchCategories.forEach((category, catindex) => {
        // if the api call matches the selected category
        if (result.config.url === category.callAPI) {
          // add the subcategories to the selected category
          let results = []
          // loop over each member result to check if it's already in the results array
          result.data.forEach((member, memberIndex) => {
            // if the member is not present in another category, add it.
            if(!inArray(result.data.id,membersIds)){
              results.push(member)
            }
            membersIds.push(member.id)
          })
          searchCategories[catindex].results = results;
        }
      })
    })

    let mailto = mailtoBuilder(searchCategories,window.location.href)

    this.setState({
      searchCategories: searchCategories,
      results: results,
      loading: false,
      mailtoLink: mailto
    })
    await this.generatePDF()
  }

  filterByTags(resultIndex,word) {
    let searchCategories = this.state.searchCategories;
    searchCategories[resultIndex].filteredResults = []
    if(searchCategories[resultIndex].activeFilter === word){
      searchCategories[resultIndex].activeFilter = null
    } else {
      searchCategories[resultIndex].activeFilter = word
      searchCategories[resultIndex].results.forEach((result, index) => {
        switch (searchCategories[resultIndex].slug) {
          case "food":
            if (result.cuisine_types.includes(word)) {
              searchCategories[resultIndex].filteredResults.push(result)
            }
            break;
          case "history":
          case "outdoor":
          case "shopping":
          case "recreation":
          case "tours":
            if (result.sub_category_tags.includes(word)) {
              console.log('test',word,result.sub_category_tags.includes(word))
              searchCategories[resultIndex].filteredResults.push(result)
            }
            break;
          case 'art':
            if (result.field_place_urban_type.includes(word)) {
              searchCategories[resultIndex].filteredResults.push(result)
            }
            break;
          case 'hotels':
            if (result.accommodation_type.includes(word)) {
              searchCategories[resultIndex].filteredResults.push(result)
            }
            break;
        }
      })
    }
    this.setState({
      searchCategories: searchCategories
    })
  }

  async generatePDF() {
    try {
      const pdfBlob = await createPdf(<MyDocument lang={LANG} searchCategories={this.state.searchCategories} />).toBlob();
      const url = URL.createObjectURL(pdfBlob);
      this.setState({pdfUrl: url})
    } catch (err) {
      // console.error('Error generating PDF:', err);
    }
  }

  render() {

    if (this.state.results.length == 0) {
      return (
        <div className="section-member-cards minheight">
          {LANG === 'fr' ? <h2 style={{textAlign:'center'}}>Attendez, nous allons chercher les<br/>meilleures recommandations pour vous !</h2> : <h2 style={{textAlign:'center'}}>Hold on, we are fetching<br/>the best recommendations for you!</h2>}
          {(this.state.loading === true) ?
            <div className="loading trip-loading">
              <svg width="70px" height="70px" viewBox="140 -1 68 70" version="1.1" id="SJN_PHYhsG"><g id="rkHuwrY2jG" fillRule="evenodd"><g id="HJUuvrK3sf"><g id="rJPdPBFnoM_HkudSK2oz"><path d="M0.1640625,28.1757812 C5.79354297,33.2055813 11.3312056,35.7432439 16.7770503,35.788769 C22.222895,35.8342942 27.6687397,33.3884495 33.1145845,28.4512349 C39.1033043,33.9747803 44.909886,36.781362 50.5343296,36.87098 C56.1587732,36.960598 61.7832168,34.3361544 67.4076604,28.9976492 C73.8347605,35.0245907 79.9290891,38.1189193 85.6906461,38.280635 C91.4522032,38.4423507 97.2137602,35.6807936 102.975317,29.9959639 C109.444473,35.7527492 115.437072,38.7453478 120.953113,38.9737596 C126.469154,39.2021713 131.985196,36.6861299 137.501237,31.4256352 C143.143013,36.0387188 148.515214,38.4109199 153.617841,38.5422385 C158.720467,38.6735571 163.823093,36.5709309 168.925719,32.2343598 C174.985169,37.9062501 180.86526,40.7863407 186.565991,40.8746315 C192.266722,40.9629222 197.967453,38.2621911 203.668184,32.7724381 C209.227767,37.9814772 214.823277,40.5769865 220.454712,40.5589659 C226.086148,40.5409454 231.717583,37.9095099 237.349018,32.6646595 C243.480762,39.422327 249.809573,42.7511384 256.335453,42.6510937 C262.861332,42.5510491 269.387212,39.0251696 275.913091,32.0734552 C281.933116,37.6303339 287.759216,40.4564339 293.391391,40.5517552 C299.023567,40.6470765 304.655742,38.0149012 310.287917,32.6552291 C316.005362,38.9498739 322.064831,42.0093431 328.466325,41.8336367 C334.867819,41.6579303 341.269313,38.2564362 347.670807,31.6291543 C353.197442,36.7591832 358.754763,39.3165046 364.342772,39.3011187 C369.930781,39.2857328 375.518789,36.697724 381.106798,31.5370922" id="rJPdPBFnoM"/></g><circle id="HkuuPrFnoG" cx="173.5" cy="33.5" r="33.5"/></g></g></svg>
            </div> : null}
        </div>
      )
    }

    return (
      <>
        {this.state.pdfUrl ? (
          <a id="pdf-download" href={this.state.pdfUrl} download="my-trip-results.pdf" className="hidden" target="_blank">Download PDF</a>
        ) : null}
        <a id="mailto-link" className="hidden" href={this.state.mailtoLink}>Email list</a>
        {this.state.searchCategories.map((result, index) => {
          if(result.results.length === 0) return (
            <>
              <div
                className="four-column-grid w-clearfix flex-row acenter tleft justify-start space">
                <img src={result.icon} className="icon"
                     alt={result.name}/>
                  <h2 className="icon-h2">{result.resultLine}</h2>
              </div>
              <div className="four-column-grid w-clearfix">
              {LANG === 'fr' ? <p className='tleft'>Malheureusement, il n'y a pas de résultats correspondants pour "{result.subCategories}"</p> : <p className='tleft'>Unfortunately there is not results matching for "{result.subCategories}"</p>}
              </div>
            </>
          );
          return (
            <div key={index}>
              <div
                className="four-column-grid w-clearfix flex-row acenter tleft justify-start space">
                <img src={result.icon} className="icon"
                     alt={result.name}/>
                  <h2 className="icon-h2">{result.resultLine}</h2>
              </div>
              <div className="section-member-cards"
                   ref={(ref) => this.pillarRef = ref}>
                <div className="blue-header">
                  <div className="main-wrapper flex">
                    {result.subCategories.length > 0 ? (
                      <select
                        className="blue-pillar select-blue-pillar hide-desktop trip-results-select"
                        onChange={(event) => this.filterByTags(index, event.target.value)}
                      >
                        {result.subCategories.split(',').map((subCategory, subindex) => (
                          <option key={subindex} value={subCategory}>
                            {subCategory}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <div className="blue-pillar hide-desktop" style={{ cursor: 'default' }}>
                        {result.title}
                      </div>
                    )}

                    { result.subCategories.length > 0 ?
                      <>
                        {
                          result.subCategories.split(',').map((subCategory, subindex) => {
                            return (
                              <div className="blue-pillar hide-mobile" onClick={() => this.filterByTags(index,subCategory)} key={subindex}>
                                {subCategory}
                              </div>
                            )
                          })
                        }
                      </>
                      :
                      <div className="blue-pillar hide-mobile" style={{cursor:'default'}}>
                        {result.title}
                      </div>
                    }


                  </div>
                </div>
                <div className="four-column-grid w-clearfix">
                  {result.activeFilter ?
                    <div className="tleft filter">{result.activeFilter} ({result.filteredResults.length})</div>:null
                  }
                  <PaginatedItems
                    itemsPerPage={4}
                    members={result.filteredResults.length ? result.filteredResults:result.results}
                    lang={LANG}
                  />
                </div>
              </div>
            </div>

          )
        })
        }
      </>

    )
  }
}

export default TripResults;
